import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';


const TripCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [name, setName] = useState("");
    const [startAutometereReading, setStartAutometereReading] = useState("");
    const [endAutometereReading, setEndAutometereReading] = useState("");
    const [isSubmit, setisSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [orderDate, setOrderDate] = useState(new Date().toISOString().split('T')[0]); // Initialize with current date

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const clearForm = () => {
        setName("");

    };

    //SalesMan

    const [selectedProduct, setSelectedProduct] = useState("");
    const [salesManOptions, setSalesManOptions] = useState([]);
    const [selectedSalesMan, setSelectedSalesMan] = useState("");

    const fetchSalesMan = async () => {
        try {
            // const response = await fetchData('executiveApi', `/${companyId}`, token);

            const response = await fetchData('executiveApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.firstName
                }));
                setSalesManOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleSalesManChange = (selectedOption) => {
        setSelectedSalesMan(selectedOption);
    };

    useEffect(() => {
        fetchSalesMan();
    }, []);


    //Driver

    const [driverOptions, setDriverOptions] = useState([]);
    const [selectedDriver, setSelectedDriver] = useState("");

    const fetchDriver = async () => {
        try {
            // const response = await fetchData('StaffSelectionApi', `/${companyId}`, token);
            const response = await fetchData('DriverstaffApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.firstName
                }));
                setDriverOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleDriverChange = (selectedOption) => {
        setSelectedDriver(selectedOption);
    };

    useEffect(() => {
        fetchDriver();
    }, []);


    //Vehicle

    const [vehicleOptions, setVehicleOptions] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState("");

    const fetchVechile = async () => {
        try {
            const response = await fetchData('VehicleApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.vehicleNo
                }));
                setVehicleOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleVehicleChange = (selectedOption) => {
        setSelectedVehicle(selectedOption);
    };

    useEffect(() => {
        fetchVechile();
    }, []);

    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);

    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('RouteApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name
                }));
                setRouteOptions(options);

            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleRouteTypeChange = (selectedOption) => {
        setSelectedRoute(selectedOption);
    };
    useEffect(() => {
        fetchRouteTypes();
    }, []);

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");
    const handleChange = (event) => {
        setSelectedPaymentType(event.target.value);

    };


    const submitData = async (e) => {
        e.preventDefault();

        if (!name) {
            setErrorMessage("All fields are required!");
            setisSubmit(false);
            setIsLoading(true);
            return;
        }

        const CreateData = {
            Description: name,
            SalesManId: selectedSalesMan.value,
            DriverId: selectedDriver.value,
            VehicleId: selectedVehicle.value,
            RouteId: selectedRoute.value,
            StartAutometereReading: startAutometereReading || null,
            EndAutometereReading: endAutometereReading || null,
            TripDate: orderDate,
            GSt_NonGST : selectedPaymentType,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('TripApi', CreateData, token)
            .then((response) => {
                console.log('trip Created success:', response);
                setSuccessMessage("Trip Created successfully!");
                setErrorMessage("");
                setSelectedDriver("");
                setSelectedRoute("");
                setSelectedVehicle("");
                setSelectedSalesMan("");
                setSelectedPaymentType("");
                clearForm();

                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
                setIsLoading(false);
            });
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h4 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>Trip Create</h4>

                        <Tooltip title="Exit">
                            <Link to="/Home" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                    Exit <ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>


                        <Tooltip title="SAVE">

                            <Button onClick={submitData} style={{ color: 'darkolivegreen', fontWeight: 'bolder', marginLeft: '2px' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>

                        </Tooltip>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex">
                        <div className="w-1/6 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="OrderDate">
                                OrderDate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date"
                                value={orderDate}
                                onChange={(e) => setOrderDate(e.target.value)}
                                style={{ width: '200px' }}
                            />
                        </div>
                        <div className="w-1/2 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                Trip
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Enter trip"
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                Route
                            </label>
                            <Select
                                value={selectedRoute}
                                onChange={handleRouteTypeChange}
                                options={routeOptions}
                                placeholder="Select Route"
                                isSearchable
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                SalesMan
                            </label>

                            <Select
                                value={selectedSalesMan}
                                onChange={handleSalesManChange}
                                options={salesManOptions}
                                placeholder="SalesMan"
                                isSearchable
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                Driver
                            </label>

                            <Select
                                value={selectedDriver}
                                onChange={handleDriverChange}
                                options={driverOptions}
                                placeholder="Driver"
                                isSearchable
                            />
                        </div>



                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                Vehicle
                            </label>

                            <Select
                                value={selectedVehicle}
                                onChange={handleVehicleChange}
                                options={vehicleOptions}
                                placeholder="Vehicle"
                                isSearchable
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                Start Audometer
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={startAutometereReading}
                                onChange={(e) => setStartAutometereReading(e.target.value)}
                                type="text"
                                placeholder="Enter Start Audometer"
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                End Audometer
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={endAutometereReading}
                                onChange={(e) => setEndAutometereReading(e.target.value)}
                                type="text"
                                placeholder="Enter End Audometer"
                            />
                        </div>

                        <div className="w-1/2 radio-group" style={{ marginLeft: '10px' }}>
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="PinCode">
                                {/* GST or NONGST */}
                            </label>
                            <div className="flex items-center">
                                <label className="block uppercase tracking-wide  font-bold mr-2" style={{ color: 'darkgreen' }}>
                                    <input type="radio" name="PaymentType" value="1"
                                        checked={selectedPaymentType === "1"}
                                        onChange={handleChange} />
                                    GST
                                </label>
                                <label className="block uppercase tracking-wide font-bold mr-2" style={{ color: 'darkred' }}>
                                    <input type="radio" name="PaymentType" value="2"
                                        checked={selectedPaymentType === "2"}
                                        onChange={handleChange} />
                                    Non-GST
                                </label>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
        </Fragment>
    );
}

export default TripCreate;

